import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans fee-engine (clés `fees.*` et `nav.fees.*`).
 *
 * Les clés vivent dans les fragments `features/fee-engine/i18n/*.json`
 * et seront fusionnées dans `src/locales/*.json` lors du câblage final
 * par le coordinateur : tant que la fusion n'est pas faite,
 * `TFunctionType` (dérivé de fr.json) ne les connaît pas encore, d'où
 * le cast.
 */
export const useFeeEngineTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
